@if (mostrarAreaSuspensao()) {
    <div>
        <div class="mb-6">
            @if (loadingSuspensoes()) {
                <div class="text-color-secondary text-sm mb-2">Carregando períodos de suspensão...</div>
            }
            @if (!loadingSuspensoes() && erroSuspensoes()) {
                <div class="text-red-500 text-sm mb-2">{{ erroSuspensoes() }}</div>
            }
            <p-table [value]="suspensoes()" styleClass="p-datatable-sm w-full" [tableStyle]="{ width: '100%' }" stripedRows fluid>
                <ng-template pTemplate="header">
                    <tr>
                        <th class="text-sm">Data Início</th>
                        <th class="text-sm">Data Final</th>
                        <th class="text-sm">Suspensão Convencional</th>
                        <th class="text-sm">Divulga Portal</th>
                        <th class="text-sm">Observação</th>
                        <th class="text-sm text-center">Anexo</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <td class="text-sm">{{ row.dtInicio }}</td>
                        <td class="text-sm">{{ row.dtFinal }}</td>
                        <td class="text-sm">{{ row.inSuspConv }}</td>
                        <td class="text-sm">{{ row.inDivulgaPortal }}</td>
                        <td class="text-sm">{{ row.txObservacao }}</td>
                        <td class="text-center">
                            <p-button icon="pi pi-download" severity="info" [text]="true" [rounded]="true" [disabled]="!row.temDocumento" (onClick)="baixarAnexo.emit(row)" title="Baixar anexo"></p-button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="6" class="text-center">
                            <div class="table-empty-state">
                                <span class="table-empty-state-icon"><i class="pi pi-search"></i></span>
                                <p class="table-empty-state-title">Nenhum período de suspensão encontrado.</p>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
}
